import { Component, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'eui-card-header-subtitle',
    templateUrl: './eui-card-header-subtitle.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EuiCardHeaderSubtitleComponent {

    @HostBinding('class') string = 'eui-card-header__title-container-subtitle';

    constructor( ) {
    }
}
